import type { LocalizedArticle } from '@/types/article';
import { completeGuide } from '@/mocks/richArticles/completeGuide';

export const richArticles: LocalizedArticle[] = [completeGuide];

export function getRichArticle(slug: string): LocalizedArticle | undefined {
  return richArticles.find((a) => a.slug === slug);
}